module.exports = __webpack_public_path__ + "img/spc-sidebar-mobile.d824195.png";